import pako from 'pako';
import decodeLittleEndian from './decodeLittleEndian.js';
import { trimToNativeFrame } from './nativeFrameBytes.js';
async function decodeDeflatedFrame(imageFrame, pixelData) {
    let inflated;
    try {
        inflated = pako.inflateRaw(new Uint8Array(pixelData.buffer, pixelData.byteOffset, pixelData.length));
    }
    catch (error) {
        throw new Error(`decodeDeflatedFrame: could not inflate the frame (${error})`);
    }
    return decodeLittleEndian(imageFrame, trimToNativeFrame(imageFrame, inflated, 'decodeDeflatedFrame'));
}
export default decodeDeflatedFrame;
